var map = {
	"./Flag_of_Afghanistan.svg": 370,
	"./Flag_of_Albania.svg": 371,
	"./Flag_of_Algeria.svg": 372,
	"./Flag_of_Angola.svg": 373,
	"./Flag_of_Argentina.svg": 374,
	"./Flag_of_Armenia.svg": 375,
	"./Flag_of_Aruba.svg": 376,
	"./Flag_of_Australia.svg": 377,
	"./Flag_of_Austria.svg": 378,
	"./Flag_of_Bahamas.svg": 379,
	"./Flag_of_Bahrain.svg": 380,
	"./Flag_of_Bangladesh.svg": 381,
	"./Flag_of_Barbados.svg": 382,
	"./Flag_of_Belarus.svg": 383,
	"./Flag_of_Belgium.svg": 384,
	"./Flag_of_Benin.svg": 385,
	"./Flag_of_Bermuda.svg": 386,
	"./Flag_of_Bhutan.svg": 387,
	"./Flag_of_Bolivia.svg": 388,
	"./Flag_of_Bosnia_and_Herzegovina.svg": 389,
	"./Flag_of_Botswana.svg": 390,
	"./Flag_of_Brazil.svg": 391,
	"./Flag_of_Brunei.svg": 392,
	"./Flag_of_Bulgaria.svg": 393,
	"./Flag_of_Cambodia.svg": 394,
	"./Flag_of_Cameroon.svg": 395,
	"./Flag_of_Canada.svg": 396,
	"./Flag_of_Cayman_Islands.svg": 397,
	"./Flag_of_Chile.svg": 398,
	"./Flag_of_China.svg": 399,
	"./Flag_of_Colombia.svg": 400,
	"./Flag_of_Cook_Islands.svg": 401,
	"./Flag_of_Costa_Rica.svg": 402,
	"./Flag_of_Croatia.svg": 403,
	"./Flag_of_Cuba.svg": 404,
	"./Flag_of_Cyprus.svg": 405,
	"./Flag_of_Czech_Republic.svg": 406,
	"./Flag_of_Denmark.svg": 407,
	"./Flag_of_Dominican_Republic.svg": 408,
	"./Flag_of_Ecuador.svg": 409,
	"./Flag_of_Egypt.svg": 410,
	"./Flag_of_El_Salvador.svg": 411,
	"./Flag_of_Estonia.svg": 412,
	"./Flag_of_Eswatini.svg": 413,
	"./Flag_of_European_Union.svg": 414,
	"./Flag_of_Fiji.svg": 415,
	"./Flag_of_Finland.svg": 416,
	"./Flag_of_France.svg": 417,
	"./Flag_of_Gabon.svg": 418,
	"./Flag_of_Gambia.svg": 419,
	"./Flag_of_Georgia.svg": 420,
	"./Flag_of_Germany.svg": 421,
	"./Flag_of_Ghana.svg": 422,
	"./Flag_of_Greece.svg": 423,
	"./Flag_of_Guatemala.svg": 424,
	"./Flag_of_Guyana.svg": 425,
	"./Flag_of_Hong_Kong.svg": 426,
	"./Flag_of_Iceland.svg": 427,
	"./Flag_of_India.svg": 428,
	"./Flag_of_Indonesia.svg": 429,
	"./Flag_of_Iran.svg": 430,
	"./Flag_of_Iraq.svg": 431,
	"./Flag_of_Ireland.svg": 432,
	"./Flag_of_Isle_of_Man.svg": 433,
	"./Flag_of_Italy.svg": 434,
	"./Flag_of_Jamaica.svg": 435,
	"./Flag_of_Japan.svg": 436,
	"./Flag_of_Jordan.svg": 437,
	"./Flag_of_Kazakhstan.svg": 438,
	"./Flag_of_Kenya.svg": 439,
	"./Flag_of_Kiribati.svg": 440,
	"./Flag_of_Kosovo.svg": 441,
	"./Flag_of_Kuwait.svg": 442,
	"./Flag_of_Kyrgyzstan.svg": 443,
	"./Flag_of_Laos.svg": 444,
	"./Flag_of_Latvia.svg": 445,
	"./Flag_of_Lebanon.svg": 446,
	"./Flag_of_Lesotho.svg": 447,
	"./Flag_of_Libya.svg": 448,
	"./Flag_of_Liechtenstein.svg": 449,
	"./Flag_of_Lithuania.svg": 450,
	"./Flag_of_Luxembourg.svg": 451,
	"./Flag_of_Macau.svg": 452,
	"./Flag_of_Malawi.svg": 453,
	"./Flag_of_Malaysia.svg": 454,
	"./Flag_of_Maldives.svg": 455,
	"./Flag_of_Malta.svg": 456,
	"./Flag_of_Marshall_Islands.svg": 457,
	"./Flag_of_Mauritius.svg": 458,
	"./Flag_of_Mexico.svg": 459,
	"./Flag_of_Moldova.svg": 460,
	"./Flag_of_Monaco.svg": 461,
	"./Flag_of_Mongolia.svg": 462,
	"./Flag_of_Montenegro.svg": 463,
	"./Flag_of_Mozambique.svg": 464,
	"./Flag_of_Myanmar.svg": 465,
	"./Flag_of_Namibia.svg": 466,
	"./Flag_of_Nauru.svg": 467,
	"./Flag_of_Nepal.svg": 468,
	"./Flag_of_Netherlands.svg": 469,
	"./Flag_of_New_Zealand.svg": 470,
	"./Flag_of_Nicaragua.svg": 471,
	"./Flag_of_Nigeria.svg": 472,
	"./Flag_of_Niue.svg": 473,
	"./Flag_of_North_Macedonia.svg": 474,
	"./Flag_of_Norway.svg": 475,
	"./Flag_of_Oman.svg": 476,
	"./Flag_of_Pakistan.svg": 477,
	"./Flag_of_Panama.svg": 478,
	"./Flag_of_Papua_New_Guinea.svg": 479,
	"./Flag_of_Paraguay.svg": 480,
	"./Flag_of_Peru.svg": 481,
	"./Flag_of_Philippines.svg": 482,
	"./Flag_of_Poland.svg": 483,
	"./Flag_of_Portugal.svg": 484,
	"./Flag_of_Qatar.svg": 485,
	"./Flag_of_Romania.svg": 486,
	"./Flag_of_Russia.svg": 487,
	"./Flag_of_Rwanda.svg": 488,
	"./Flag_of_Samoa.svg": 489,
	"./Flag_of_San_Marino.svg": 490,
	"./Flag_of_Saudi_Arabia.svg": 491,
	"./Flag_of_Senegal.svg": 492,
	"./Flag_of_Serbia.svg": 493,
	"./Flag_of_Seychelles.svg": 494,
	"./Flag_of_Singapore.svg": 495,
	"./Flag_of_Slovakia.svg": 496,
	"./Flag_of_Slovenia.svg": 497,
	"./Flag_of_Solomon_Islands.svg": 498,
	"./Flag_of_Somalia.svg": 499,
	"./Flag_of_South_Africa.svg": 500,
	"./Flag_of_South_Korea.svg": 501,
	"./Flag_of_Spain.svg": 502,
	"./Flag_of_Sri_Lanka.svg": 503,
	"./Flag_of_Sudan.svg": 504,
	"./Flag_of_Suriname.svg": 505,
	"./Flag_of_Sweden.svg": 506,
	"./Flag_of_Switzerland.svg": 507,
	"./Flag_of_Syria.svg": 508,
	"./Flag_of_Taiwan.svg": 509,
	"./Flag_of_Tanzania.svg": 510,
	"./Flag_of_Thailand.svg": 511,
	"./Flag_of_Timor_Leste.svg": 512,
	"./Flag_of_Togo.svg": 513,
	"./Flag_of_Tonga.svg": 514,
	"./Flag_of_Trinidad_and_Tobago.svg": 515,
	"./Flag_of_Tunisia.svg": 516,
	"./Flag_of_Turkey.svg": 517,
	"./Flag_of_Turks_and_Caicos_Islands.svg": 518,
	"./Flag_of_Tuvalu.svg": 519,
	"./Flag_of_Uganda.svg": 520,
	"./Flag_of_Ukraine.svg": 521,
	"./Flag_of_United_Arab_Emirates.svg": 522,
	"./Flag_of_United_Kingdom.svg": 523,
	"./Flag_of_United_States.svg": 524,
	"./Flag_of_Vanuatu.svg": 525,
	"./Flag_of_Venezuela.svg": 526,
	"./Flag_of_Vietnam.svg": 527,
	"./Flag_of_Yemen.svg": 528,
	"./Flag_of_Zambia.svg": 529,
	"./Flag_of_Zimbabwe.svg": 530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 369;